import { gql } from '@apollo/client';

export const SEARCH = gql`
  query search($query: String!) {
    search(query: $query) {
      destinations {
        countryCode
        subdivision
        city
        country
        postCount
      }
      users {
        username
        displayName
        avatar
      }
    }
  }
`;
